<div class="dialog">
    <div class="dialog-header">
        <h3>{{ data.editMode ? ('COMPLAINT_APPOINTMENT|Edycja wizyty' | translate) : ('COMPLAINT_APPOINTMENT|Planowanie wizyty' | translate) }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

            <icc-complaint-appointment-edit
                [(complaint)]="data.complaint"
                [(complaintAppointment)]="data.appointment"
                [(complaintAppointmentAttachments)]="data.attachments"
                [(editMode)]="data.editMode"
                (validDate)="validateDate($event)"
            ></icc-complaint-appointment-edit>

    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>
            <button
                [disabled]="!data.appointment.date || isValidDate"
                iccButton
                (click)="save()"
                appearance="primary"
            >
                {{ 'INTERFACE|Zapisz' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>